<template>
  <div v-if="workflowData" class="card shadow border rounded-3 mb-3">
    <div class="card-body pb-1">
      <div class="d-flex justify-content-center">
        <CustomTabs :tabs="tabs" :model-value="activeTab" @update:modelValue="onTabChanged" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomTabs from "@/components/CustomTab/CustomTab.vue";

export default {
  name: 'TabsNavigation',
  components: {
    CustomTabs
  },
  props: {
    workflowData: {
      type: Object,
      default: null
    },
    activeTab: {
      type: String,
      default: 'overview'
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onTabChanged(tabValue) {
      this.$emit('update:activeTab', tabValue);
    }
  }
}
</script>

<style scoped></style>
